import { ChangeEvent, MouseEvent, useState } from 'react';

interface UsePaginationReturnTypes {
  page: number;
  rowsPerPage: number;
  handleChangePage: (
    event: ChangeEvent<unknown> | null,
    newPage: number,
    cb?: (isNext: boolean) => void
  ) => void;
  handleChangeRowPerPage: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onCustomNextButton: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const usePagination = (
  tableRowsPerPage?: number | undefined,
  onClickNextButtonHandler?: (event: MouseEvent<HTMLButtonElement>) => void
): UsePaginationReturnTypes => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(tableRowsPerPage || 20);
  /** @function
   * @name handleChangePage
   * @description
   * It changes the page number.
   * @param {MouseEvent<{}> | null} event
   * @param {number} newPage
   */
  const handleChangePage = (
    event: ChangeEvent<unknown> | null,
    newPage: number
  ): void => {
    setPage(newPage - 1);
  };
  /** @function
   * @name handleChangeRowPerPage
   * @description
   * It sets the row per page by the default is ten.
   * @param {ChangeEvent<HTMLInputElement | HTMLTextAreaElement>} event
   */
  const handleChangeRowPerPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  /** @function
   * @name onCustomNextButton
   * @description
   * It performs a custom behavior of the next button. Mostly, It modifies behavior such as fetch an API. But
   * the default functionality is still the same just add some additional behavior.
   * @param {MouseEvent<HTMLButtonElement>} event
   */
  const onCustomNextButton = (event: MouseEvent<HTMLButtonElement>): void => {
    if (onClickNextButtonHandler) {
      onClickNextButtonHandler(event);
      handleChangePage(null, page + 1);
    }
  };

  return {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowPerPage,
    onCustomNextButton,
  };
};

export default usePagination;
